import React, { useEffect, useState } from 'react';
import classes from '../CheckTile.module.css';
import cn from 'classnames';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const TileFooter = ({ section, check, onFooterButtonPress, currentMode }) => {
  const BASE_STATUS_CONFIG = {
    pending: [
      { name: FLABEL().CHECK_NOTIFY, key: 'notify' },
      { name: FLABEL().CHECK_PROGRESS, key: 'inProgress' },
    ],
    inProgress: [
      { name: FLABEL().CHECK_NOTIFY, key: 'notify' },
      { name: FLABEL().CHECK_COMPLETE, key: 'complete' },
    ],
    complete: [
      { name: FLABEL().CHECK_NOTIFY, key: 'notify' },
      { name: FLABEL().CHECK_PICKEDUP, key: 'pickedUp' },
    ],
    pickedUp: [
      { name: FLABEL().CHECK_NOTIFY, key: 'notify' },
      { name: FLABEL().CHECK_PICKEDUP, key: 'pickedUp', disable: true },
    ],
  };

  const MODE_STATUS_BUTTONS = {
    DEFAULT: { ...BASE_STATUS_CONFIG },

    OFF_PREMISE: { ...BASE_STATUS_CONFIG },

    TABLE_DELIVERY: { ...BASE_STATUS_CONFIG },

    OFF_PREMISE_VENUE: { ...BASE_STATUS_CONFIG },

    ON_PREMISE: {
      pending: [
        { name: FLABEL().CHECK_PRINT, key: 'print' },
        { name: FLABEL().CHECK_RECEIPT, key: 'receipt' },
      ],
      inProgress: [
        { name: FLABEL().CHECK_PRINT, key: 'print' },
        { name: FLABEL().CHECK_RECEIPT, key: 'receipt' },
      ],
      complete: [
        { name: FLABEL().CHECK_PRINT, key: 'print' },
        { name: FLABEL().CHECK_RECEIPT, key: 'receipt' },
      ],
      pickedUp: [
      { name: FLABEL().CHECK_NOTIFY, key: 'print' },
      { name: FLABEL().CHECK_PICKEDUP, key: 'receipt' },
    ],
    },
  };

  const buttons = MODE_STATUS_BUTTONS[currentMode]?.[section?.key] || [];

  const onClickButton = actionType => {
    onFooterButtonPress && onFooterButtonPress(actionType, check);
  };

  return (
    <div className={cn(classes.footerContainer, 'fs_16 row mx-0 pb-2 px-1')}>
      {buttons.map(button => (
        <div className="col-6 px-1" key={button.key}>
          <button
            className={cn(
              classes.actionButton,
              'col-12 p-2',
              button?.disable && classes.disabledbtn
            )}
            onClick={() => !button?.disable && onClickButton(button.key)}
          >
            <span className={classes.buttonText}>{button.name}</span>
          </button>
        </div>
      ))}
    </div>
  );
};

export default TileFooter;
